import React from 'react'
import './Stepper.scss'

interface Step {
    id: number
    label: string
}

interface Props {
    steps: Step[]
    currentStep: number
    className?: string
}

const Stepper: React.FunctionComponent<Props> = ({steps, currentStep, className = ''}) => {
    return (
        <div className={`stepper ${className}`}>
            {steps.map((step) => (
                <div
                  key={step.id}
                  className={`step-item ${currentStep === step.id ? 'active' : ''} ${currentStep > step.id ? 'completed': ''}`}
                >
                    <div className="step-circle">{step.id}</div>
                    <span>{step.label}</span>
                </div>
            ))}
        </div>
    )
}

export { Stepper }